<div class="my-plans-modal" *ngIf="modalData">
    <div class="main" *ngIf="!saved">
        <p class="description">
            {{modalData.description}} <strong>{{modalData.entity.name}}</strong>
        </p>
        <div class="schedules">
            <div class="date">
                <finder-date-picker-wrapper
                    [labels]="modalData.calendarLabels"
                    [(date)]="scheduleService.date"
                    (dateChanged)="onDateChanged($event)"
                    [disabled]="myPlansService.isSaving"
                    (datePickerClose)="onCalendarClose($event)">
                        <label class="label">{{modalData.dateLabel}}*</label>
                        <finder-input
                            class="date-input"
                            type="text"
                            [value]="scheduleService.fullFormatDate"
                            readonly="readonly">
                        </finder-input>
                </finder-date-picker-wrapper>
            </div>
            <finder-loading-spinner class="schedule-spinner" *ngIf="scheduleService.isLoading"></finder-loading-spinner>
            <div class="time-section" [hidden]="scheduleService.isLoading">
                <ng-container *ngIf="times === 'buttons'">
                    <div class="times">
                        <finder-button *ngFor="let time of timesList"
                            theme="tertiary"
                            [fitText]="true"
                            [selected]="isTimeSelected(time)"
                            [disabled]="myPlansService.isSaving"
                            (click)="setDate(time)">
                            {{time.startTimeOutput}}
                        </finder-button>
                    </div>
                </ng-container>
                <ng-container *ngIf="times === 'select'">
                    @defer {
                        <finder-ra-single-select
                            [hidden]="scheduleService.isLoading"
                            [disabled]="myPlansService.isSaving"
                            [label]="modalData.selectLabel"
                            [options]="selectOptions"
                            (itemSelected)="onSelectedTime($event?.detail.value)">
                        </finder-ra-single-select>
                    }
                </ng-container>
                <ng-container *ngIf="emptySchedules">
                    <div class="empty-time" [hidden]="scheduleService.isLoading">
                        {{scheduleService.schedule?.labels.emptySchedule}}
                    </div>
                </ng-container>
            </div>
        </div>
        <hr>
        <div class="share">
            <p class="share-title">{{modalData.shareTitle}}</p>
            <div class="select-all" *ngIf="showCheckAll">
                @defer {
                    <finder-ra-checkbox
                        class="checkbox"
                        [checked]="selectAllChecked"
                        (checkedChanged)="onSelectAllChange($event)">
                    </finder-ra-checkbox>
                }
                <p>{{modalData.fnf.selectAll}}</p>
            </div>
            <div class="friends-and-family" [@elementState]="fnfState">
                <finder-avatar-checkbox *ngFor="let guest of fnfList"
                    class="guest"
                    [guest]="guest"
                    [checked]="guest.checked"
                    [disabled]="guest.primaryGuest || myPlansService.isSaving || guest.disabled"
                    [age]="guestAge(guest)"
                    (checkedChanged)="onCheckedGuest($event)">
                </finder-avatar-checkbox>
                <div class="empty-fnf" *ngIf="fnfList.length === 1">
                    <finder-breadcrumb class="breadcrumb"
                        [links]="fnfBreadcrumb"
                        breadcrumb="{{modalData.fnf.breadcrumbTemplate}}">
                    </finder-breadcrumb>
                </div>
            </div>
            <finder-loading-spinner class="fnf-spinner" *ngIf="keyringServiceLoading"></finder-loading-spinner>
        </div>
    </div>
    <div class="success-banner" *ngIf="saved" [@elementState]="saved ? 'displayed' : ''">
        <div class="header">
            <finder-font-icon class="title-icon" color="green" size="xl" name="checkmark"></finder-font-icon>
            <div class="title">
                <span class="text">{{modalData.successMessage}}</span>
                <finder-anchor class="anchor" href="/plan/">{{modalData.viewPlanAnchor}}</finder-anchor>
            </div>
        </div>
        <hr>
        <div class="details">
            <div class="entity">
                <div class="schedule">
                    <finder-font-icon class="schedule-icon" size="xl" name="entertainment"></finder-font-icon>
                    <div class="schedule-details">
                        <p class="schedule-title">{{modalData.scheduleTitle}}</p>
                        <p class="schedule-time">{{selectedDate?.startTimeOutput}}</p>
                    </div>
                </div>
                <finder-picture class="entity-image" [picture]="modalData.media"></finder-picture>
                <div class="entity-info">
                    <p class="entity-name">{{modalData.entity.name}}</p>
                    <p class="entity-location">{{modalData.entity.location}}</p>
                </div>
            </div>
            <div class="guests">
                <div class="summary">
                    <p>{{this.myPlan.guests.length}} {{modalData.guestsLabel}}</p>
                </div>
                <div class="list">
                    <finder-avatar
                        *ngFor="let guest of getSelectedGuests()"
                        class="guest"
                        [title]="guest.firstName"
                        [subtitle]="guest.lastName"
                        [detail]="guestAge(guest)"
                        [avatar]="guest.avatar">
                    </finder-avatar>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="actions">
        <p class="footer-text">{{modalData.footerText}}</p>
        <div class="save-section" *ngIf="!saved">
            <finder-loading-spinner class="saving-spinner" *ngIf="myPlansService.isSaving"></finder-loading-spinner>
            <finder-button
                class="add-to-plans"
                [ngClass]="{'hidden':myPlansService.isSaving}"
                (click)="save()"
                [disabled]="disableButton"
                theme="primary">
                    {{modalData.actions.addToPlansButtonText}}
            </finder-button>
        </div>
        <finder-button
            class="cancel"
            (click)="dismiss()"
            *ngIf="!saved"
            theme="secondary">
                {{modalData.actions.cancelButtonText}}
        </finder-button>
        <finder-button class="close" *ngIf="saved" (click)="dismiss()" theme="primary">
            {{modalData.actions.closeButtonText}}
        </finder-button>
    </div>
</div>
